import type { TagProps } from '@fourthwall/components'
import type { GetShopPaymentMethodsResponse } from '@fourthwall/services/dist/PaymentApiClient'

import { formatExpiresAt } from './formatExpiresAt'
import { isPaymentMethodFailed } from './isPaymentMethodFailed'

const getPaymentMethodProps = (paymentMethod: GetShopPaymentMethodsResponse['result'][number]) => {
  const result: TagProps[] = []

  if (paymentMethod.default) {
    result.push({
      label: 'Default',
      appearance: 'default',
    })
  }

  if (paymentMethod.status === 'FAILED') {
    result.push({
      label: 'Failed',
      appearance: 'critical',
    })
  }

  return result
}

export const mapPaymentMethods = (response: GetShopPaymentMethodsResponse) =>
  response.result.map((paymentMethod) => {
    if (paymentMethod.details.type === 'CARD') {
      return {
        id: paymentMethod.id,
        type: 'CARD' as const,
        brand: paymentMethod.details.brand,
        number: paymentMethod.details.last4Digits,
        expires: formatExpiresAt(paymentMethod.details.expiresAt),
        expired: paymentMethod.details.expired,
        tagsProps: getPaymentMethodProps(paymentMethod),
        default: paymentMethod.default,
        invalid: isPaymentMethodFailed(paymentMethod),
      }
    }

    // PAYPAL
    return {
      id: paymentMethod.id,
      type: 'PAYPAL' as const,
      email: paymentMethod.details.email,
      tagsProps: getPaymentMethodProps(paymentMethod),
      default: paymentMethod.default,
      invalid: isPaymentMethodFailed(paymentMethod),
    }
  })
